import { render } from "./HowToBuyTruthGptCryptoCoin.vue?vue&type=template&id=4bf7818e"
const script = {}

import exportComponent from "/codebuild/output/src1708070281/src/vestoolywebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__